module.exports = __webpack_public_path__ + "media/tnr/bghead-old-5452502d.png";